import { useEffect, useState } from 'react'
import useWebConfigAttributes from './useWebConfigAttributes'
import { WebsiteConfig, getWebConfig } from 'lib/webConfig/webConfig'

const useWebConfig = () => {
    const [webConfig, setWebConfig] = useState<WebsiteConfig>({})
    const userAttributes = useWebConfigAttributes()

    useEffect(() => {
        if (!userAttributes) {
            setWebConfig({})
            return
        }

        setWebConfig(getWebConfig(userAttributes) ?? {})
    }, [userAttributes])

    return webConfig
}

export default useWebConfig
